import { render, staticRenderFns } from "./MobileGutter.vue?vue&type=template&id=2bff0e5e&scoped=true&"
import script from "./MobileGutter.vue?vue&type=script&lang=js&"
export * from "./MobileGutter.vue?vue&type=script&lang=js&"
import style0 from "./MobileGutter.vue?vue&type=style&index=0&id=2bff0e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff0e5e",
  null
  
)

export default component.exports